export default __webpack_public_path__ + "static/media/map.53af4b0c.png";